import * as z from "zod/v4";
import { ProfileEmailSourceSchema } from "./profile-email-source.js";

const ProfileSearchFiltersSchema_ = z.object({
  email: z.string().optional(),
  phoneNumber: z.string().optional(),
  name: z.string().optional(),
  emailSource: ProfileEmailSourceSchema.optional(),
});
export const ProfileSearchFiltersSchema: z.ZodType<ProfileSearchFilters> =
  ProfileSearchFiltersSchema_;
export interface ProfileSearchFilters
  extends z.infer<typeof ProfileSearchFiltersSchema_> {}
